const RULE_CHECKS = {
	MIN_LENGTH: (password) => [...password].length >= 8,
	LOWERCASE: (password) => /[a-z]/.test(password),
	UPPERCASE: (password) => /[A-Z]/.test(password),
	DIGIT: (password) => /[0-9]/.test(password),
	SPECIAL: (password) => /[^a-zA-Z0-9]/.test(password),
};

export default class BPasswordRequirements
{
	constructor(el)
	{
		this.el = el;
		this.input = this.resolvePasswordInput();
		this.items = [...this.el.querySelectorAll(".b-password-requirements__item[data-rule]")];
		if (!this.input || this.items.length === 0) {
			return;
		}

		this.refresh = this.refresh.bind(this);
		this.input.addEventListener("input", this.refresh);
		this.input.addEventListener("change", this.refresh);
		this.refresh();
	}

	static selector = () => "[data-b-password-requirements]";

	static initialize()
	{
		document.querySelectorAll(this.selector()).forEach((el) => {
			new this(el);
		});
	}

	resolvePasswordInput()
	{
		const authField = this.el.closest(".jp-auth__field");
		if (authField) {
			return authField.querySelector("input[type=\"password\"]");
		}

		const profileField = this.el.closest(".jp-profile-form__field");
		if (profileField) {
			return profileField.querySelector("input[type=\"password\"]");
		}

		const inputContainer = this.el.closest(".b-input-row__input");
		if (inputContainer) {
			return inputContainer.querySelector("input[type=\"password\"]");
		}

		const form = this.el.closest("form");
		if (!form) {
			return null;
		}

		return form.querySelector("input[type=\"password\"]");
	}

	refresh()
	{
		const password = this.input.value ?? "";
		for (const item of this.items) {
			const ruleCode = item.dataset.rule;
			const check = RULE_CHECKS[ruleCode];
			const isMet = check ? check(password) : false;
			const icon = item.querySelector(".b-password-requirements__icon");
			item.classList.toggle("b-password-requirements__item--met", isMet);
			if (icon) {
				icon.textContent = isMet ? "check_circle" : "radio_button_unchecked";
			}
		}
	}
}
